import React, { Component } from 'react';

import './SumarioGri.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';
import renderHTML from 'react-render-html';
import $ from 'jquery';

import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images,
	relatorio_content
} from '../../settings';

import {
	DelayLink,
} from '../../components';

class SumarioGri extends Component {

	constructor() {
		super();

		this.$ = $;

        this.images = images;
        this.relatorio_content = relatorio_content;

        this.state = {
            width: window.innerWidth,
            tabsActive: null
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);
	    this.changeTabs = this.changeTabs.bind(this);
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    globalTransition() {
    	Actions.globalTransition();
    }

    changeTabs(i) {
    	const { tabsActive } = this.state;
    	console.log(tabsActive, i);
    	this.setState({
    		tabsActive: (tabsActive == i) ? null : i
    	});

    	let target = $('.accordion__item:nth-child('+ (i + 1) +')');
		setTimeout(function() {
			this.$("html, body").stop().animate({ scrollTop: target.offset().top }, 500, 'swing');
		}.bind(this), 100);
    }

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('09 Sumário GRI');
    }

    componentWillUnmount() {
	}

    componentDidMount() {
    	this.setState({ tabsActive: null });
    }

	render() {
        const { width, tabsActive } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view',
			'sumario'
		];


        return (

			<div className="views" id="scene">
			
				<Helmet>
	                <title>09 Sumário GRI - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>09</span> Sumário GRI</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Sumário GRI</p>
		        			</div>
		        		</header>

		        		<div className="views__content first__view row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
					        			<span className="gri_label"><text>GRI 102-55</text></span>
				        			</Fade>
				        		</div>
			        		</div>
			        	</div>

		        		<div className="views__content second__view row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
				        				<h2>Divulgações gerais</h2>

				        				<Accordion>

								        	<AccordionItem className={ (tabsActive == 0 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
									            <AccordionItemTitle>
									                <h3 onClick={this.changeTabs.bind(null, 0)}>Perfil organizacional</h3>
									            </AccordionItemTitle>
									            <AccordionItemBody>

									                <h3>GRI 102: Divulgações gerais 2016</h3>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/quem-somos/perfil" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-1</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Nome da organização</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/quem-somos/perfil" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-2</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Atividades, marcas, produtos e serviços</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/quem-somos/perfil" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-3</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Localização da sede</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/quem-somos/perfil" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-4</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Localização das operações</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/quem-somos/perfil" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-5</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Natureza da propriedade e forma jurídica</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/quem-somos/perfil" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-6</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Mercados atendidos</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/pessoas" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-7</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Porte da organização</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/pessoas/perfil" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-8</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Informações sobre empregados e trabalhadores</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri">
										                	<span className="gri_label"><text>GRI 102-9</text></span>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Cadeia de fornecedores</h4>
										                	<p>Mais de mil empresas de diversas áreas de atuação e categorias de produtos e serviços.</p>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri">
										                	<span className="gri_label"><text>GRI 102-10</text></span>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Mudanças significativas na organização e na sua cadeia de fornecedores</h4>
										                	<p>Em abril de 2018, incorporamos as atividades do Instituto BRAiN (Brasil Investimentos & Negócios), organização que fundamos em 2016 em parceria com outras entidades com o objetivo de transformar o Brasil em um centro de investimentos e negócios para a América Latina.</p>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri">
										                	<span className="gri_label"><text>GRI 102-12</text></span>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Iniciativas desenvolvidas externamente</h4>
										                	<p>Desde 2006, somos membros do Conselho-Técnico Consultivo do CDP (Carbon Disclosure Project) e do Conselho Brasileiro para o Desenvolvimento Sustentável do Mercado.</p>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/quem-somos/perfil" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-13</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Participação em associações</h4>
										                </div>
									                </div>

									            </AccordionItemBody>
									        </AccordionItem>

								        	<AccordionItem className={ (tabsActive == 1 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
									            <AccordionItemTitle>
									                <h3 onClick={this.changeTabs.bind(null, 1)}>Estratégia</h3>
									            </AccordionItemTitle>
									            <AccordionItemBody>

									                <h3>GRI 102: Divulgações gerais 2016</h3>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/mensagens" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-14</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Declaração do tomador de decisão sênior</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/estrategia/curto-prazo" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-15</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Principais impactos, riscos e oportunidades</h4>
										                </div>
									                </div>

									            </AccordionItemBody>
									        </AccordionItem>

								        	<AccordionItem className={ (tabsActive == 2 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
									            <AccordionItemTitle>
									                <h3 onClick={this.changeTabs.bind(null, 2)}>Ética e integridade</h3>
									            </AccordionItemTitle>
									            <AccordionItemBody>

									                <h3>GRI 102: Divulgações gerais 2016</h3>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/governanca-corporativa/conselho-de-etica" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-16</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Valores, princípios, padrões e normas de comportamento</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/governanca-corporativa/conselho-de-etica" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-17</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Mecanismos de aconselhamento e preocupações sobre ética</h4>
										                </div>
									                </div>

									            </AccordionItemBody>
									        </AccordionItem>

								        	<AccordionItem className={ (tabsActive == 3 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
									            <AccordionItemTitle>
									                <h3 onClick={this.changeTabs.bind(null, 3)}>Governança</h3>
									            </AccordionItemTitle>
									            <AccordionItemBody>

									                <h3>GRI 102: Divulgações gerais 2016</h3>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/governanca-corporativa/assembleia-geral" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-18</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Estrutura da governança</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/estrategia/plano-de-acao" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-21</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Consulta aos stakeholders sobre tópicos econômicos, ambientais e sociais</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/governanca-corporativa/assembleia-geral" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-22</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Composição do mais alto órgão de governança e dos seus comitês</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri">
										                	<span className="gri_label"><text>GRI 102-23</text></span>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Presidente do mais alto órgão de governança</h4>
										                	<p>A Assembleia não possui presidente.</p>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/governanca-corporativa/assembleia-geral" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-24</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Selecionando e nomeando o mais alto órgão de governança e seus comitês</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/governanca-corporativa/diretoria" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-25</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Conflitos de interesse</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/governanca-corporativa/assembleia-geral" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-26</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Papel do mais alto órgão de governança na definição do propósito, valores e estratégias</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri">
										                	<span className="gri_label"><text>GRI 102-28</text></span>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Avaliação de desempenho do mais alto órgão de governança</h4>
										                	<p>Não há.</p>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri">
										                	<span className="gri_label"><text>GRI 102-35</text></span>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Políticas de remuneração</h4>
										                	<p>Todos os membros da Assembleia, Diretoria e Conselhos Fiscal e de Ética são voluntários.</p>
										                </div>
									                </div>

									            </AccordionItemBody>
									        </AccordionItem>

								        	<AccordionItem className={ (tabsActive == 4 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
									            <AccordionItemTitle>
									                <h3 onClick={this.changeTabs.bind(null, 4)}>Engajamento de stakeholders</h3>
									            </AccordionItemTitle>
									            <AccordionItemBody>

									                <h3>GRI 102: Divulgações gerais 2016</h3>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri">
										                	<span className="gri_label"><text>GRI 102-41</text></span>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Acordos de negociação coletiva</h4>
										                	<p>100% dos funcionários são submetidos a acordos de negociação coletiva.</p>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/estrategia/relacionamentos" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-42</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Identificação e seleção de stakeholders</h4>
										                </div>
									                </div>

									            </AccordionItemBody>
									        </AccordionItem>

								        	<AccordionItem className={ (tabsActive == 5 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
									            <AccordionItemTitle>
									                <h3 onClick={this.changeTabs.bind(null, 5)}>Práticas de reporte</h3>
									            </AccordionItemTitle>
									            <AccordionItemBody>

									                <h3>GRI 102: Divulgações gerais 2016</h3>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/sobre-o-relatorio" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-46</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Definindo o conteúdo do relatório e limite do tópico</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/sobre-o-relatorio" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-48</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Reformulações de informações</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/sobre-o-relatorio" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-49</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Mudanças no relatórios</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/sobre-o-relatorio" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-50</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Período do relatório</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/sobre-o-relatorio" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-51</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Data do relatório mais recente</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri">
										                	<span className="gri_label"><text>GRI 102-52</text></span>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Ciclo do relatório</h4>
										                	<p>Anual.</p>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/sobre-o-relatorio" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-53</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Ponto de contato para perguntas sobre o relatório</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/sobre-o-relatorio" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-54</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Opção de acordo com o GRI Standards</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/sumario-gri" delay={1000}>
										                		<span className="gri_label"><text>GRI 102-55</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Sumário de Conteúdo GRI</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri">
										                	<span className="gri_label"><text>GRI 102-56</text></span>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Asseguração externa</h4>
										                	<p>Não há.</p>
										                </div>
									                </div>

									            </AccordionItemBody>
									        </AccordionItem>

					        			</Accordion>
					        			
				        			</Fade>
				        		</div>
			        		</div>
			        	</div>

		        		<div className="views__content third__view row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
				        				<h2>Tópicos materiais</h2>

					        			<Accordion>

									        <AccordionItem className={ (tabsActive == 6 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
									            <AccordionItemTitle>
									                <h3 onClick={this.changeTabs.bind(null, 6)}>Emprego</h3>
									            </AccordionItemTitle>
									            <AccordionItemBody>

									                <h3>GRI 103: Abordagem de gestão 2016</h3>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/pessoas/qualidade-de-vida" delay={1000}>
										                		<span className="gri_label"><text>GRI 103-1</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Explicação sobre o tópico material e seus limites</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/pessoas/qualidade-de-vida" delay={1000}>
										                		<span className="gri_label"><text>GRI 103-2</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Abordagem de gestão e seus componentes</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/pessoas/qualidade-de-vida" delay={1000}>
										                		<span className="gri_label"><text>GRI 103-3</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Evolução da abordagem de gestão</h4>
										                </div>
									                </div>

									                <br /><br />
									                <h3>GRI 401: Emprego</h3>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri">
										                	<span className="gri_label"><text>GRI 401-2</text></span>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Benefícios concedidos a empregados de tempo integral que não são oferecidos a empregados temporários ou em regime de meio período</h4>
										                	<p>Estagiários e jovens aprendizes não têm direito a auxílio-creche e vale-alimentação.</p>
										                </div>
									                </div>

									            </AccordionItemBody>
									        </AccordionItem>

									        <AccordionItem className={ (tabsActive == 7 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
									            <AccordionItemTitle>
									                <h3 onClick={this.changeTabs.bind(null, 7)}>Treinamento e educação</h3>
									            </AccordionItemTitle>
									            <AccordionItemBody>

									                <h3>GRI 103: Abordagem de gestão 2016</h3>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/pessoas/engajamento" delay={1000}>
										                		<span className="gri_label"><text>GRI 103-1</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Explicação sobre o tópico material e seus limites</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/pessoas/engajamento" delay={1000}>
										                		<span className="gri_label"><text>GRI 103-2</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Abordagem de gestão e seus componentes</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/pessoas/engajamento" delay={1000}>
										                		<span className="gri_label"><text>GRI 103-3</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Evolução da abordagem de gestão</h4>
										                </div>
									                </div>

									                <br /><br />
									                <h3>GRI 404: Treinamento e educação</h3>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri" onClick={this.globalTransition}>
										                	<DelayLink to="/pessoas/engajamento" delay={1000}>
										                		<span className="gri_label"><text>GRI 404-1</text></span>
										                	</DelayLink>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Média de horas de treinamento por ano por empregado</h4>
										                </div>
									                </div>

									                <div className="gri_line">
										                <div className="gri_line__column gri_line__column--gri">
										                	<span className="gri_label"><text>GRI 404-3</text></span>
										                </div>
										                <div className="gri_line__column gri_line__column--text">
										                	<h4>Percentual de empregados que recebem regularmente análises de desempenho e de desenvolvimento de carreira</h4>
										                	<p>100% dos empregados são avaliados anualmente em três etapas: autoavaliação, avaliação do gestor e reunião de consenso, que é quando funcionário e gestor conversam sobre a aderência entre o comportamento praticado e o esperado.</p>
										                </div>
									                </div>

									            </AccordionItemBody>
									        </AccordionItem>

					        			</Accordion>
					        			
				        			</Fade>
				        		</div>
			        		</div>
			        	</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { SumarioGri };
